import { useState, useEffect } from "react";

import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import { FormInput } from "../FormComponents";
import { getTargetSite } from "../../../data/siteData";

import SkeletonForm from "../../Skeletons/SkeletonForm";

const EditSiteForm = (props: any) => {
  const [visible, setVisible] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const [formState, setFormState] = useState({
    siteAddr: "",
    postcode: "",
    deletedDate: "",
  });
  const [loading, setLoading] = useState(true);
  const siteId = props.onSiteId;

  const toggleDeleteDialog = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    const fetchPlaceholderData = async () => {
      const site = await getTargetSite(siteId);
      setFormState({
        siteAddr: site.siteAddr,
        postcode: site.postcode,
        deletedDate: site.deletedDate,
      });

      setLoading(false);

      if (site.deletedDate !== null) {
        setIsDeleted(true);
      } else {
        setIsDeleted(false);
      }
    };

    fetchPlaceholderData();
  }, [siteId]);

  const handleSubmit = () => {
    // alert(JSON.stringify(formState, null, 2));
    console.log(formState)
    props.onEditSubmit(formState, siteId);
  };

  const handleDelete = () => {
    props.onSiteDelete(siteId);
    toggleDeleteDialog();
  };

  return loading ? (
    <SkeletonForm />
  ) : (
    <div className="form__wrapper">
      <div style={{ display: "flex", width: "100%" }}>
        <Form
          initialValues={{
            siteAddr: formState.siteAddr,
            postcode: formState.postcode,
          }}
          onSubmit={handleSubmit}
          render={(formRenderProps) => (
            <FormElement
              style={{ padding: "1rem", width: "100%", marginBottom: "5rem" }}
            >
              <fieldset className={"k-form-fieldset"}>
                <div className="form__subtitle">Edit site details:</div>

                <Field
                  name={"siteAddr"}
                  component={FormInput}
                  label={"Site address:"}
                  defaultValue={formState.siteAddr}
                  placeholder={formState.siteAddr}
                  onChange={(e) => {
                    setFormState({ ...formState, siteAddr: e.value });
                  }}
                />

                <Field
                  name={"postcode"}
                  component={FormInput}
                  label={"Site postcode: "}
                  defaultValue={formState.postcode}
                  placeholder={formState.postcode}
                  onChange={(e) => {
                    setFormState({ ...formState, postcode: e.value });
                  }}
                />

                {isDeleted ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      padding: "1rem 2rem 1rem 2rem",
                      position: "absolute",
                    }}
                  >
                    <button
                      onClick={() => {
                        formRenderProps.onFormReset();
                      }}
                      className="form__edit__button edit"
                    >
                      Reinstate site
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      bottom: 0,
                      left: 0,
                      width: "100%",
                      padding: "1rem 2rem 1rem 2rem",
                      position: "absolute",
                    }}
                  >
                    <button
                      onClick={() => {
                        handleSubmit();
                        formRenderProps.onFormReset();
                      }}
                      className="form__edit__button edit"
                    >
                      Save changes to Site
                    </button>
                    <button
                      onClick={toggleDeleteDialog}
                      className="form__edit__button reject"
                    >
                      Mark Site as Deleted
                    </button>
                  </div>
                )}
              </fieldset>
            </FormElement>
          )}
        />
      </div>
      {visible && (
        <Dialog title={"Please confirm"} onClose={toggleDeleteDialog}>
          <p
            style={{
              margin: "25px",
              textAlign: "center",
            }}
          >
            Are you sure you want to delete {formState.siteAddr}?
          </p>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={toggleDeleteDialog}
            >
              No
            </button>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={handleDelete}
            >
              Yes
            </button>
          </DialogActionsBar>
        </Dialog>
      )}
    </div>
  );
};

export default EditSiteForm;
